import Config from "cortex-config";
import LDClient from "launchdarkly-js-client-sdk";

let ldClient = null;

const noopLDClient = {
  allFlags: async () => ({}),
  identify: async () => ({}),
};

export async function initializeLaunchDarkly(session, reinitialize = false) {
  const user = session
    ? {
        kind: "user",
        key: session.userId,
        email: session.email,
      }
    : {
        kind: "user",
        anonymous: true,
      };

  try {
    if (!ldClient || reinitialize) {
      ldClient = LDClient.initialize(Config.LAUNCH_DARKLY_CLIENT_ID, user);
      await new Promise((resolve, reject) => {
        ldClient.on("ready", resolve);
        ldClient.on("failed", reject);
      });
    } else {
      console.log("LaunchDarkly already initialized");
    }
    return await ldClient.allFlags();
  } catch (error) {
    console.error("LaunchDarkly initialization failed, using noop client", error);
    ldClient = noopLDClient;
    return await ldClient.allFlags();
  }
}

export async function identifyUser(user) {
  if (!ldClient) {
    throw new Error("LaunchDarkly client is not initialized");
  }
  try {
    await ldClient.identify({
      key: user.id,
      email: user.email,
      custom: {
        account_id: user.account_id,
      },
    });
    return await ldClient.allFlags();
  } catch (error) {
    console.error("LaunchDarkly identify failed, using noop client", error);
    ldClient = noopLDClient;
    return ldClient.allFlags();
  }
}
